import { render, staticRenderFns } from "./WorkflowManagement.vue?vue&type=template&id=4ef4a267&scoped=true"
import script from "./WorkflowManagement.vue?vue&type=script&lang=js"
export * from "./WorkflowManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4a267",
  null
  
)

export default component.exports